// extracted by mini-css-extract-plugin
export default {"tumbleweed":"#dab177","link":"nk","wrapper":"nl"};